export const studentTypes = {
  SET_STUDENT: "SET_STUDENT",
  GET_STUDENT: "GET_STUDENT",
  GET_STUDENTS: "GET_STUDENTS",
  UPDATE_STUDENT: "UPDATE_STUDENT",
  UPDATE_STATESTUDENT: "UPDATE_STATESTUDENT",
};
